import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	changeBoardingLozengeLabel: {
		id: 'issue-view-jpd-ideas.change-boarding-lozenge.label',
		defaultMessage: 'New',
		description: 'Lozenge that indicates that the new functionality is present',
	},
});
